export { default } from "./ClickFilterableTable";
